<template>
	<div class="container-details">
		<div class="container-top">
			<div class="payment-values">
				<BoxSmall
					:linear-gradient="{
						bgInital: '#0db2de',
						bgFinal: '#005bea',
					}"
					background-color="#fb8500"
					title="Valor Acréscimo"
					:subtitle="transformToBrl(pedido.vlrtotalacrescimo)"
					:icon="{
						type: 'trending-up',
						size: '35px',
						color: '#000000',
					}"
				/>
				<BoxSmall
					:linear-gradient="{
						bgInital: '#f76a2d',
						bgFinal: '#efa65f',
					}"
					background-color="#fb8500"
					title="Valor ST"
					:subtitle="transformToBrl(pedido.vlrtotalstpedido)"
					:icon="{
						type: 'file-text',
						size: '35px',
						color: '#000000',
					}"
				/>
				<BoxSmall
					:linear-gradient="{
						bgInital: '#f7778c',
						bgFinal: '#f93a5a',
					}"
					background-color="#fb8500"
					title="Desconto"
					:subtitle="transformToBrl(pedido.vlrtotaldesconto)"
					:icon="{
						type: 'trending-down',
						size: '35px',
						color: '#000000',
					}"
				/>
				<BoxSmall
					:linear-gradient="{
						bgInital: '#48d6a8',
						bgFinal: '#029666 ',
					}"
					background-color="#fb8500"
					title="Valor Total"
					:subtitle="transformToBrl(pedido.vlrtotalpedido)"
					:icon="{
						type: 'dollar-sign',
						size: '35px',
						color: '#000000',
					}"
				/>
			</div>
			<div class="container-order-details">
				<div class="top-container-details">
					<div class="header-pedido">
						<feather type="home" size="16px" class="icon-title-info" />
						<h1>Empresa</h1>
					</div>
					<div class="empresa-detalhes">
						<div class="details-empresa">
							<div>
								<h1>
									Razão Social: <span>{{ pedido.nomerazao }}</span>
								</h1>
							</div>
							<div>
								<h1>
									Fantasia: <span>{{ pedido.empresa_fantasia }}</span>
								</h1>
							</div>
							<!-- <div>
                <h1>
                  CPNJ: <span>{{ pedido.empresa_fantasia }}</span>
                </h1>
              </div> -->
							<div>
								<h1>
									ID: <span>{{ pedido.empresa_id }}</span>
								</h1>
							</div>
						</div>
					</div>
				</div>
				<div class="top-container-details">
					<div class="header-pedido">
						<feather type="credit-card" size="16px" class="icon-title-info" />
						<h1>Pagamento</h1>
					</div>
					<div class="empresa-detalhes">
						<div class="details-empresa">
							<div>
								<h1>
									Forma de Pagamento: <span>{{ pedido.formpgto_desc }}</span>
								</h1>
							</div>
							<div>
								<h1>
									Condição: <span>{{ pedido.condpgto_desc }}</span>
								</h1>
							</div>
							<!--   <div>
                <h1>Cartão: <span>####-####-####-3232</span></h1>
              </div> -->
						</div>
					</div>
				</div>
				<div class="top-container-details">
					<div class="header-pedido">
						<feather type="file-text" size="16px" class="icon-title-info" />
						<h1>Pedido #{{ pedido.id }}</h1>
					</div>
					<div class="empresa-detalhes">
						<div class="details-empresa">
							<div>
								<h1>
									Tabela De Vendas: <span>{{ pedido.tabvnd_desc }}</span>
								</h1>
							</div>
							<div>
								<h1>
									Data Criação: <span>{{ dateTimeToBrasil(pedido.created_at) }}</span>
								</h1>
							</div>
							<div>
								<h1>
									Integração ID:
									<span>{{ pedido.integracao_id ? pedido.integracao_id : 'Não informado' }}</span>
								</h1>
							</div>
							<div>
								<h1>
									Situação: <span>{{ situacaoDesc[pedido.situacao] }}</span>
								</h1>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="container-row">
				<div class="container-history" :style="{ width: observacao.length === 0 ? '100%' : '49%' }">
					<div class="title">
						<h1>Histórico</h1>
					</div>
					<div class="box-history">
						<b-table :data="historyPedido">
							<b-table-column
								v-slot="props"
								field="situacao"
								label="Situação"
								header-class="custom-header"
							>
								<h1 class="row-text">
									{{ props.row.situacao_desc }}
								</h1>
							</b-table-column>
							<b-table-column
								v-slot="props"
								field="dtsituacao"
								header-class="custom-header"
								label="Data"
							>
								<h1 class="row-text">
									{{ props.row.dtsituacao }}
								</h1>
							</b-table-column>
						</b-table>
					</div>
				</div>
				<Timeline
					v-if="observacao.length > 0"
					margin-bottom="40px"
					title="Observações"
					width="49%"
					:data="observacao"
				/>
			</div>
			<div class="container-products">
				<div style="padding: 15px">
					<div class="header-products">
						<h1>Produtos</h1>
						<search width="35%" height="35px" @searchtext="searchTerm = $event" />
					</div>
					<div class="container-table-product">
						<productable :is-loading="isLoading" :rows="myData" />
					</div>
				</div>
			</div>
		</div>
		<b-loading v-model="isLoading" :is-full-page="false" :can-cancel="false" />
	</div>
</template>
<script>
import search from '../../layout/components/search';
import productable from '../../layout/components/table/detail';
import global from '../../mixins/global';
import * as ecAxios from '../../util/ecAxios';
import BoxSmall from '../../layout/components/box/rounded-small';
import Timeline from '../../layout/components/timeline/default';

export default {
	components: {
		search,
		productable,
		BoxSmall,
		Timeline,
	},
	mixins: [global],
	data() {
		return {
			searchTerm: '',
			isLoading: true,
			situacaoDesc: {
				0: 'Salvo',
				1: 'Finalizado',
				2: 'Integrado',
				3: 'Inválido',
				4: 'Em Análise',
				5: 'Liberado',
				6: 'Faturado',
				7: 'Cancelado',
				8: 'Transporte',
				9: 'Entregue',
				10: 'Aguardando Pagamento',
				11: 'Em rota',
			},
			historyPedido: [],
			pedido: {},
			produtos: [],
			observacao: [],
		};
	},
	computed: {
		myData() {
			const searchData = this.searchTerm;
			if (searchData) {
				return this.produtos.filter(
					(item) => this.filterSearch(item.descricao) || this.filterSearch(item.produto_id)
				);
			}
			return this.produtos;
		},
		pedidoData() {
			return this.pedido;
		},
	},
	activated() {
		this.getDetailsPedido();
		this.getHistory();
		this.getObservation();
	},
	methods: {
		async getObservation() {
			const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.EC_SHOW_OBSERVATION}/2/${this.$route.params.id}`;
			const response = await ecAxios.connection().get(url);
			if (response.data.error === 0) {
				this.observacao = response.data.observacao;
			} else {
				this.$buefy.notification.open({
					message: response.data.message,
					type: 'is-danger',
				});
			}
		},
		async getHistory() {
			this.isLoading = true;
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_PED_SITUACAO_LOG}`, {
					pedido_id: this.$route.params.id,
				})
				.then((response) => {
					this.historyPedido = response.data.pedidosituacaolog;
					const newHistoryPedido = [];
					this.historyPedido.map((item) => {
						// eslint-disable-next-line no-param-reassign
						item.dtsituacao = this.dateTimeToBrasil(item.dtsituacao);
						newHistoryPedido.push(item);
						return true;
					});
					this.historyPedido = newHistoryPedido;
				})
				.catch((e) => {
					this.$buefy.notification.open({
						message: e.toString(),
						type: 'is-warning',
					});
				});
			this.isLoading = false;
		},
		async getDetailsPedido() {
			this.isLoading = true;
			let onlyDeleted = false;
			const filters = JSON.parse(localStorage.getItem('filters'));

			if (filters && filters.statusdata && filters.statusdata === 1) {
				onlyDeleted = true;
			}
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_PEDIDO_DETALHES}`, {
					id: this.$route.params.id,
					only_deleted: onlyDeleted,
					busca_valores: true,
				})
				.then((response) => {
					this.pedido = response.data.data.pedido;
					this.produtos = response.data.data.produtos;
				})
				.catch((e) => {
					this.$buefy.notification.open({
						message: e.toString(),
						type: 'is-warning',
					});
				});
			this.isLoading = false;
		},

		filterSearch(field) {
			if (typeof field === 'number') {
				// eslint-disable-next-line no-param-reassign
				field = field.toString();
			}
			if (field === null) {
				// eslint-disable-next-line no-param-reassign
				field = '';
			}
			return field.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1;
		},
	},
};
</script>

<style scoped lang="scss">
.container-history {
	display: flex;
	flex-direction: column;
	background-color: #fff;
	padding: 20px;
	margin-bottom: 40px;
	border-radius: 5px;
	border: 1px solid #deebfd;
	box-shadow: -8px 12px 18px 0 #dadee8;
}
.container-row {
	display: flex;
	justify-content: space-between;
	flex-direction: row;
	width: 100%;
}
.row-history {
	display: flex;
	align-items: center;
	justify-content: space-between;
}
/* Produtos */
.header-products {
	display: flex;
	width: 100%;
	height: 37px;
	margin-top: 10px;
	margin-bottom: 20px;
	align-items: center;
	justify-content: space-between;
}
.container-products {
	display: flex;
	width: 100%;
	background-color: #fff;
	box-sizing: border-box;
	flex-direction: column;
	border-radius: 5px;
	border: 1px solid #deebfd;
	box-shadow: -8px 12px 18px 0 #dadee8;
	margin-bottom: 30px;
}
.header-products h1 {
	font-size: 16px;
	font-weight: bold;
}

.row-text {
	display: flex;
	color: $row-color;
	font-weight: $row-weight;
	margin-top: 5px;
	margin-bottom: 2px;
	font-size: $row-size;
}

.custom-header {
	font-size: $header-size;
	font-weight: $header-weight;
	color: $header-color;
}
.search-container-box {
	display: flex;
	height: 50px;
}

/* Ordem Detalhes */

.top-container-details {
	width: 33%;
}
.empresa-detalhes,
.historico-detalhes,
.pagamento-detalhes {
	width: 100%;
	background-color: #fff;
}
.container-order-details {
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	width: 100%;
	justify-content: flex-start;
	margin-bottom: 40px;
	background-color: #fff;
	padding: 20px;
	margin-top: 30px;
	border-radius: 5px;
	border: 1px solid #deebfd;
	box-shadow: -8px 12px 18px 0 #dadee8;
}

.container-top {
	display: flex;
	width: 100%;
	flex-direction: column;
	/*   justify-content: space-between; */
}
.details-empresa div {
	display: flex;
	margin-top: 5px;
	align-items: center;
}

.payment-value-red {
	background-color: #0c5df4;
}
.payment-value-blue {
	background-color: #3c096c;
}
.payment-value-green {
	background-color: #157b48;
}
.payment-value-cyan {
	background-color: #ff930a;
}
.payment-value-box {
	width: 24%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 15px;
	border-radius: 8px;
	margin-bottom: 30px;
	cursor: pointer;
}
.payment-values {
	display: flex;
	width: 100%;
	justify-content: space-between;
}
.title-payment-box {
	display: flex;
}
.title h1 {
	font-size: 16px;
	font-weight: bold !important;
}
.title-payment-box h1 {
	margin: 5px;
	font-size: 17px;
	color: #fff;
	font-weight: 600;
}
.trending-up {
	color: #fff;
}
.icon-title-info {
	margin-right: 6px;
	color: #4a4a4a;
}
.details-empresa div h1 {
	font-size: 14px;
	font-weight: bold;
	color: #4a4a4a;
	margin-top: 12px;
}
.details-empresa div h1 span {
	font-size: 14px;
	font-weight: normal;
	color: #343a40;
}
.details-empresa div h2 {
	margin-left: 10px;
	font-size: 14px;
	color: #3c394e;
	margin-top: 7px;
}

.header-pedido {
	display: flex;
	align-items: center;
	flex-direction: row;
	justify-content: flex-start;
	font-size: 16px;
	color: #343a40;
}

.header-pedido h1 span {
	color: #6e6893;
}
.header-pedido h1 {
	font-weight: bold;
	margin-top: 20px;
	margin-bottom: 20px;
}
.container-details {
	width: 100%;
	display: flex;
	flex-direction: column;
}
</style>

